__webpack_require__.p = "https://magnify.qa.magmutual.com/";